// extracted by mini-css-extract-plugin
module.exports = {"jobsFeed":"JobsFeed_jobsFeed__fp1vf","jobs":"JobsFeed_jobs__S_FcZ","job":"JobsFeed_job__U1BR_"};